import { render, staticRenderFns } from "./modalNotasEnfermeria.vue?vue&type=template&id=211d5cf0&"
import script from "./modalNotasEnfermeria.vue?vue&type=script&lang=js&"
export * from "./modalNotasEnfermeria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports